import React from 'react';
import { Ear, Wrench, HandshakeIcon, Scale } from 'lucide-react';
import { Reveal, SectionEyebrow, SectionTitle, SectionBody, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const icons = [Ear, Wrench, HandshakeIcon, Scale];

const Approach = () => {
  const { t } = useLanguage();
  return (
    <section
      id="approach"
      data-testid={SITE.sectionApproach}
      className="relative py-20 lg:py-32 bg-[#F7F8F5]"
    >
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionEyebrow>{t.approach.eyebrow}</SectionEyebrow>
            </Reveal>
            <Reveal delay={0.05}>
              <SectionTitle className="mt-4">{t.approach.title}</SectionTitle>
            </Reveal>
            <Reveal delay={0.1}>
              <SectionBody className="mt-6">{t.approach.body}</SectionBody>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {t.approach.pillars.map((p, i) => {
              const Icon = icons[i];
              return (
                <Reveal key={p.title} delay={i * 0.08}>
                  <article
                    data-testid={SITE.pillarItem}
                    className="h-full bg-white rounded-2xl p-7 border border-[rgba(0,166,81,0.1)] hover:border-[rgba(0,166,81,0.35)] transition-all duration-300 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_18px_40px_-10px_rgba(0,166,81,0.18)] hover:-translate-y-1"
                  >
                    <div className="w-11 h-11 rounded-xl bg-[#00A651]/10 flex items-center justify-center">
                      <Icon size={20} className="text-[#00A651]" />
                    </div>
                    <h3 className="mt-5 font-['Outfit'] text-lg font-semibold text-[#0B0F0C]">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed">{p.desc}</p>
                  </article>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Approach;
